
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";

export default Vue.extend({
  data() {
    return {
      showPopupConfirm: false,
      showDetailError: false,
      restarting: false,
      binding: {},
      overtime: false,
      os: null,
      error: "",
      copied: false,
      popupConfirmOptions: {}
    };
  },
  methods: {
    async copyToClipboard() {
      let text = 'sudo service mobility-suite-agent restart';
      if (this.os === 'windows') {
        text = 'net stop MobilitySuiteAgent & net start MobilitySuiteAgent';
      } else if (this.os === 'darwin') {
        text = `sudo launchctl unload -w /Library/LaunchDaemons/com.viettel.MobilitySuiteAgent.plist
        & sudo launchctl load -w /Library/LaunchDaemons/com.viettel.MobilitySuiteAgent.plist`
      }
      await navigator.clipboard.writeText(text);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 3000)
    },
    async restartService() {
      try {
        this.showPopupConfirm = false
        this.error = ""
        this.restarting = true
        const res = await msDataProvider.executeCommand("restartService", {});
        if (res && res.error) {
          this.error = res.error
          this.restarting = false
        }
      } catch (e) {
        this.error = e;
        this.restarting = false;
        window.location.reload();
      }
    },
    async goToHelpCenter() {
      const urlGuideLine  = {
        url: 'https://localhost:40001/ui/user-guide/index?focusContent=true#561-h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-restart-service-cho-windows'
      }
      try {
        await msDataProvider.executeCommand(
            "extOpenUrl",
            urlGuideLine
        );
      } catch (e) {
        console.log(e);
      }
    },
    autoReload() {
      window.location.reload();
      // const isServiceAppAlive = await msDataProvider.getData("localServiceConnected");
      // if (isServiceAppAlive) {
      //   this.$router.push("/prepare").catch((e) => e);
      // }
    }
  },
  created() {
    this.os = sessionStorage.getItem("os");
    msDataProvider.watchData(
        "localServiceConnected",
        (value) => {
          if (value) {
            localStorage.removeItem("autoReload")
            this.$router.push("/prepare").catch((e) => e);
          }
        },
        this
    );

    msDataProvider.bindDataMany(
        ["localServiceConnectError"],
        this.binding,
        this,
        null,
        this
    );

    this.popupConfirmOptions = {
      title: this.$t('APP.WARNING'),
    }

    const self = this;
    if(localStorage.getItem("autoReload") == "true") {
      setInterval(this.autoReload, 10000);
    }
    setTimeout(() => {
      self.overtime = true;
      if(!localStorage.getItem("autoReload")) {
        setTimeout(() => {
          this.autoReload();
        }, 10000)
      }
      localStorage.setItem("autoReload", "true")
    }, 15000);
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
